<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="is_data_available">
      <div class="col">
        <table class="table table-bordered table-striped">
          <tr style="background: #97cdef;">
            <th>S. No.</th>
            <th>Booth Code</th>
            <th>Old Route</th>
            <th>New Route</th>
            <th>Action</th>
            <th>Changed By</th>
            <th>Changed@</th>
          </tr>
          <tr *ngFor="let data of route_business_change_log_data; let log_index=index">
            <td>{{ log_index + 1 }}</td>
            <td>{{ data['business_code'] }}</td>
            <td>{{ data['old_route']}}</td>
            <td>{{ data['new_route'] }}</td>
            <td>{{ data['description'] }}</td>
            <td>{{ data['changed_by'] }}</td>
            <td>{{ data['changed_at'] | date : 'MMM d, y, h:mm a' }}</td>
          </tr>
        </table>
        <div style="font-size: 36px;" *ngIf="route_business_change_log_data.length == 0">There Is No Log !!!</div>
      </div>
    </div>
  </div>
</section>
